import { render, staticRenderFns } from "./CostSummary.vue?vue&type=template&id=e010eb42&scoped=true&"
import script from "./CostSummary.vue?vue&type=script&lang=ts&"
export * from "./CostSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CostSummary.vue?vue&type=style&index=0&id=e010eb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e010eb42",
  null
  
)

export default component.exports